import { isStringNotNull } from "./dataType";

const GCS_DOWNLOAD_URL_PATTERN =
  /^https:\/\/storage\.googleapis\.com\/download\/storage\/v1\/b\/([^/]+)\/o\/([^?]+)/;

export const normalizeStorageImageUrl = (
  url: string | null | undefined,
): string | null | undefined => {
  if (!isStringNotNull(url)) {
    return url ?? null;
  }

  const apiMatch = url.match(GCS_DOWNLOAD_URL_PATTERN);
  if (!apiMatch) {
    return url;
  }

  const [, bucket, encodedObject] = apiMatch;
  return `https://storage.googleapis.com/${bucket}/${decodeURIComponent(encodedObject)}`;
};

export const resolveProductImageUrl = (
  image?: string | null,
  imageCompressed?: string | null,
): string | null | undefined =>
  normalizeStorageImageUrl(
    isStringNotNull(imageCompressed) ? imageCompressed : image,
  );
